import { get, post } from '@/utils/http'

export function getNoticeAgents() {
  return get('/admin/notice/agents')
}

export function sendNotice(payload) {
  return post('/admin/notice', payload)
}

export function getAdminNoticePage(params) {
  return get('/admin/notice/page', params)
}

export function getAgentNoticeInbox(params) {
  return get('/admin/notice/inbox', params)
}

export function forwardNotice(id) {
  return post(`/admin/notice/inbox/${id}/forward`)
}
